function imgToBlob(canvas) {
  return new Promise(function (resolve) {
    canvas.toBlob(resolve, "image/jpeg");
  });
}

export const setCanvasPreview = (
  cb,
  image, // HTMLImageElement
  canvas, // HTMLCanvasElement
  crop // PixelCrop
) => {
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No 2d context");
  }

  // devicePixelRatio slightly increases sharpness on retina devices
  // at the expense of slightly slower render times and needing to
  // size the image back down if you want to download/upload and be
  // true to the images natural size.
  const pixelRatio = window.devicePixelRatio;
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = "high";
  ctx.save();

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  // Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  ctx.drawImage(
    image,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight,
    0,
    0,
    image.naturalWidth,
    image.naturalHeight
  );

  imgToBlob(canvas).then((blob) => {
    cb(blob);
  });

  /* const newImage = new Image();
  newImage.src = canvas.toDataURL();

  canvas.width = 150;
  canvas.height = 150;

  newImage.addEventListener("load", () => {
    ctx.drawImage(newImage, 0, 0, 150, 150);
    imgToBlob(canvas).then((blob) => {
      cb(blob);
    });
  }); */

  ctx.restore();
};
